var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"photos"}},[_c('LightGallery',{attrs:{"images":_vm.images,"index":_vm.index,"disable-scroll":true},on:{"close":function($event){_vm.index = null}}}),_c('ul',{staticClass:"rig"},_vm._l(([
               '/photos/thumbs/dan_8200.jpg',
               '/photos/thumbs/dan_8201.jpg',
               '/photos/thumbs/dan_8202.jpg',
               '/photos/thumbs/dan_8203.jpg',
               '/photos/thumbs/dan_8204.jpg',
               '/photos/thumbs/dan_8205.jpg',
               '/photos/thumbs/dan_8206.jpg',
               '/photos/thumbs/dan_8207.jpg',
               '/photos/thumbs/dan_8208.jpg',
               '/photos/thumbs/dan_8209.jpg',
               '/photos/thumbs/dan_8210.jpg',
               '/photos/thumbs/dan_8211.jpg',
               '/photos/thumbs/dan_8212.jpg',
               '/photos/thumbs/dan_8213.jpg',
               '/photos/thumbs/dan_8214.jpg',
               '/photos/thumbs/dan_8300.jpg',
               '/photos/thumbs/dan_8301.jpg',
               '/photos/thumbs/dan_8302.jpg',
               '/photos/thumbs/dan_8303.jpg',
               '/photos/thumbs/dan_8304.jpg',
               '/photos/thumbs/dan_8305.jpg',
               '/photos/thumbs/dan_8306.jpg',
               '/photos/thumbs/dan_8307.jpg',
               '/photos/thumbs/dan_8308.jpg',
               '/photos/thumbs/dan_8309.jpg',
               '/photos/thumbs/dan_8310.jpg',
               '/photos/thumbs/dan_8311.jpg',
               '/photos/thumbs/dan_8312.jpg',
               '/photos/thumbs/dan_8313.jpg',
               '/photos/thumbs/dan_8314.jpg',
               '/photos/thumbs/dan_8315.jpg',
               '/photos/thumbs/dan_8316.jpg',
               '/photos/thumbs/dan_8317.jpg',
               '/photos/thumbs/danschmidt_family_1.jpg',
               '/photos/thumbs/danschmidt_family_2.jpg'

    ]),function(thumb,thumbIndex){return _c('li',{key:thumbIndex,on:{"click":function($event){_vm.index = thumbIndex}}},[_c('img',{attrs:{"src":thumb}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }